var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { ExternalBankAccountService } from '@square/dashboard-protos/models/squareup/sfs/external/services/external_bank_account/external_bank_account_service';
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import { v4 as uuid } from 'uuid';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
import { ExternalBankAccount } from '@square/dashboard-protos/models/squareup/sfs/external/models/external_bank_account';
import { TransactionBlocker } from '@square/dashboard-protos/models/squareup/bank-accounts/bank_accounts';
import moment from 'moment';
import { LinkExternalBankAccountWithPlaidRequest } from '@square/dashboard-protos/models/squareup/sfs/external/services/external_bank_account/link_external_bank_account_with_plaid';
const INSTANTLY_VERIFIED = 'instantly_verified';
let SfsExternalBankAccountApi = (_dec = computed('capitalEngineContext.headers'), _dec2 = computed('externalBankAccounts'), _dec3 = computed('importableExternalBankAccounts.length'), _dec4 = computed('externalBankAccounts'), _class = class SfsExternalBankAccountApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _defineProperty(this, "externalBankAccounts", []);
    _defineProperty(this, "importableExternalBankAccounts", []);
    _defineProperty(this, "plaidLink", void 0);
  }
  get client() {
    return ExternalBankAccountService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  async listExternalBankAccounts(customerId,
  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  {
    refresh
  } = {
    refresh: false
  }) {
    if (this.externalBankAccounts.length === 0 || refresh) {
      const {
        externalBankAccounts
      } = await this.client.listExternalBankAccounts({
        customerId
      });
      set(this, 'externalBankAccounts', externalBankAccounts);
    }
    return this.externalBankAccounts;
  }
  async listImportableExternalBankAccounts(customerId,
  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  {
    refresh
  } = {
    refresh: false
  }) {
    if (this.importableExternalBankAccounts.length === 0 || refresh) {
      const {
        importableAccounts
      } = await this.client.listImportableExternalBankAccounts({
        customerId
      });
      set(this, 'importableExternalBankAccounts', importableAccounts);
    }
    return this.importableExternalBankAccounts;
  }
  linkExternalBankAccount(params) {
    return this.client.linkExternalBankAccount(Object.assign({
      idempotencyKey: uuid()
    }, params)).then(({
      externalBankAccount
    }) => {
      if (externalBankAccount) {
        set(this, 'externalBankAccounts', [externalBankAccount]);
      }
      return externalBankAccount;
    });
  }
  importExternalBankAccount(customerId, importableAccount) {
    return this.client.importExternalBankAccount({
      idempotencyKey: uuid(),
      customerId,
      importableAccount
    }).then(({
      externalBankAccount
    }) => {
      if (externalBankAccount === undefined) {
        throw new Error('import did not return the imported account');
      }

      // This invalidates the cache, we want to re-fetch them
      set(this, 'importableExternalBankAccounts', []);
      set(this, 'plaidLink', undefined);
      if (externalBankAccount) {
        set(this, 'externalBankAccounts', [externalBankAccount]);
      }
      return externalBankAccount;
    });
  }
  createPlaidLinkToken(customerId, language, isVerifyingManualDeposits) {
    return this.client.createPlaidLinkToken({
      customerId,
      language,
      isVerifyingManualDeposits
    }).then(({
      plaidLinkToken,
      gringottsSessionToken
    }) => {
      if (plaidLinkToken === undefined) {
        throw new Error('plaidLinkToken was not returned');
      }
      return {
        plaidLinkToken,
        gringottsSessionToken
      };
    });
  }
  linkExternalBankAccountWithPlaid(idempotencyKey, customerId, plaidPublicToken, plaidAccountId,
  // If verification status is empty, account has been instantly verified
  plaidVerificationStatus = INSTANTLY_VERIFIED, gringottsSessionToken) {
    let linkExternalBankAccountWithPlaidRequest = LinkExternalBankAccountWithPlaidRequest.create({
      idempotencyKey,
      customerId,
      plaidPublicToken,
      plaidAccountId,
      plaidVerificationStatus
    });
    if (gringottsSessionToken) {
      linkExternalBankAccountWithPlaidRequest = LinkExternalBankAccountWithPlaidRequest.create({
        ...linkExternalBankAccountWithPlaidRequest,
        gringottsSessionToken
      });
    }
    return this.client.linkExternalBankAccountWithPlaid(linkExternalBankAccountWithPlaidRequest).then(({
      externalBankAccount,
      verifyingPlaidLink
    }) => {
      // This invalidates the cache, we want to re-fetch
      set(this, 'plaidLink', undefined);
      if (externalBankAccount) {
        set(this, 'externalBankAccounts', [externalBankAccount]);
      }
      if (verifyingPlaidLink) {
        set(this, 'plaidLink', verifyingPlaidLink);
      }
      return {
        externalBankAccount,
        verifyingPlaidLink
      };
    });
  }

  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  async fetchPlaidLink(customerId, {
    refresh
  } = {
    refresh: false
  }) {
    if (!this.plaidLink || refresh) {
      const {
        plaidLink
      } = await this.client.getPlaidLink({
        customerId
      });
      set(this, 'plaidLink', plaidLink);
    }
    return this.plaidLink;
  }
  failPlaidLink(customerId, reason) {
    set(this, 'plaidLink', undefined);
    return this.client.failPlaidLink({
      customerId,
      reason
    });
  }
  get hasBrokenBankAccountLink() {
    return this.externalBankAccounts.some(externalBankAccount => {
      return this.isAccountLinkBroken(externalBankAccount);
    });
  }
  isAccountLinkBroken(externalBankAccount) {
    // if the only transaction blocker is that we're waiting the initial link verification, return false
    if (externalBankAccount.transactionBlockers.length === 1 && externalBankAccount.transactionBlockers[0] === TransactionBlocker.NOT_VERIFIED && externalBankAccount.linkStatus === ExternalBankAccount.LinkStatus.VERIFYING) {
      return false;
    } else {
      return externalBankAccount.transactionBlockers.length > 0;
    }
  }
  get hasImportableExternalBankAccounts() {
    return this.importableExternalBankAccounts.length > 0;
  }
  get hasLinkedExternalBankAccountWithinOneDay() {
    return this.externalBankAccounts.some(account => moment().diff(moment(account.initiatedLinkAt), 'days') < 1);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasBrokenBankAccountLink", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "hasBrokenBankAccountLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasImportableExternalBankAccounts", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "hasImportableExternalBankAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLinkedExternalBankAccountWithinOneDay", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "hasLinkedExternalBankAccountWithinOneDay"), _class.prototype), _class);
export { SfsExternalBankAccountApi as default };